import { useState } from "react";

import { DEFAULT_SORT } from "../table/components/table-sorter";

export const useTableSort = () => {
  return useState<string>(DEFAULT_SORT);
};
